module.exports = __webpack_public_path__ + "static/media/auth-background.fd0650c6.png";